import {Event, Channel} from "@unibuddy/machop/Experimental/Sockets/SocketProvider/SocketProvider";

const applicantInfoChannel = new Channel("applicant-info-group");

export const delinkApplicantEvent = new Event("applicant-delinked", applicantInfoChannel);
